import React from "react";
import Features from "../components/Features";

export default function FixedDeposit() {
  return (
    <div className="fixed-deposit-page">
      {/* HERO SECTION */}
      <section className="fd-hero">
        <div className="fd-left">
          <h1>Fixed-Term Deposits</h1>
          <p>
            Experience Swiss-grade financial stability with our Fixed-Term Deposit
            accounts. Secure your wealth with guaranteed returns over flexible terms,
            available in multiple global currencies including CHF, EUR, GBP, and USD.
            Whether you’re safeguarding personal assets or optimizing corporate
            liquidity, our structured deposits provide both confidence and clarity.
          </p>
          <p>
            Choose your preferred duration — from 3 months to 5 years — and lock in
            competitive rates backed by the trusted legacy of Swiss banking.
          </p>
        </div>
        <div className="fd-right">
          <img src="/service1.png" alt="Fixed-Term Deposit" />
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="fd-details">
        <h2>Why Choose Our Fixed-Term Deposits?</h2>
        <p>
          Our offshore Fixed-Term Deposits are ideal for clients seeking both
          security and performance. Funds are managed under strict Swiss financial
          governance and benefit from world-class confidentiality standards.
          Enjoy peace of mind knowing your investments grow under the protection
          of one of the world’s most reputable financial jurisdictions.
        </p>
        <ul>
          <li>✅ Guaranteed returns with zero market volatility</li>
          <li>✅ Available in 10+ major currencies</li>
          <li>✅ Flexible terms and early renewal options</li>
          <li>✅ Managed under Swiss financial regulatory standards</li>
        </ul>
      </section>

      {/* FEATURES SECTION */}
      <Features />
    </div>
  );
}

/* ---------------------- CSS BELOW ---------------------- */

const styles = `
.fixed-deposit-page {
  background: #f8f9fb;
  color: #1a1a1a;
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  padding-bottom: 60px;
}

.fd-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 10%;
  gap: 40px;
  background: white;
}

.fd-left {
  flex: 1;
}

.fd-left h1 {
  font-size: 2.5rem;
  color: #d21e2b;
  margin-bottom: 20px;
}

.fd-left p {
  margin-bottom: 15px;
  font-size: 1.05rem;
  color: #333;
}

.fd-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.fd-right img {
  width: 90%;
  max-width: 500px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
}

.fd-details {
  padding: 60px 10%;
  max-width: 1000px;
  margin: 0 auto;
}

.fd-details h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #111;
}

.fd-details p {
  margin-bottom: 20px;
  color: #444;
}

.fd-details ul {
  list-style: none;
  padding-left: 0;
}

.fd-details li {
  margin-bottom: 10px;
  font-size: 1rem;
}

@media (max-width: 900px) {
  .fd-hero {
    flex-direction: column;
  }
  .fd-right img {
    width: 100%;
  }
}
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}
